export default __webpack_public_path__ + "static/media/img2.9d275024.png";